import styled from 'styled-components';

export const serviceFormsListTitle = { marginBottom: 30 };

export const SectionContainer = styled.div`
  padding-bottom: 60px;
`;
